module.exports = __webpack_public_path__ + "img/zan_uc.71a2a7fb.svg";